import { useState, useRef } from 'react'

import useBreakpoint from 'Utils/useBreakpoint'

export const useSubcategoryMenu = () => {
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false)
  const hoverZoneRef = useRef(null)
  const breakpoint = useBreakpoint()
  const isMobile = ['xs', 'sm'].includes(breakpoint)

  const handleArrowClick = (e) => {
    e.preventDefault()
    if (isMobile) {
      setIsSubmenuOpen(!isSubmenuOpen)
    }
  }

  const handleCloseSubmenu = () => {
    setIsSubmenuOpen(false)
  }

  const handleHoverZoneMouseEnter = () => {
    if (!isMobile) {
      setIsSubmenuOpen(true)
    }
  }

  const handleHoverZoneMouseLeave = () => {
    if (!isMobile) {
      setIsSubmenuOpen(false)
    }
  }

  const handleSubmenuFocus = () => {
    if (!isMobile) {
      setIsSubmenuOpen(true)
    }
  }

  const handleSubmenuBlur = (e) => {
    if (hoverZoneRef.current && !hoverZoneRef.current.contains(e.relatedTarget)) {
      if (!isMobile) {
        setIsSubmenuOpen(false)
      }
    }
  }

  return {
    isSubmenuOpen,
    hoverZoneRef,
    handleArrowClick,
    handleCloseSubmenu,
    handleHoverZoneMouseEnter,
    handleHoverZoneMouseLeave,
    handleSubmenuFocus,
    handleSubmenuBlur,
  }
}
